'use client'

import { RecsForm } from '@/components/common/RecsForm'
import { Searchbar } from '@/components/common/Searchbar'
import { Splash } from '@/components/common/Splash'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { CARDART } from '@/defs/misc'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { type RecsEndpointInputsType } from '@/utils/apiUtil'

import styles from './HomeStarted.module.scss'
import { HomeStartedBrowse } from './HomeStartedBrowse/HomeStartedBrowse'

export const HomeStarted = () => {
  const { redirectUrl } = useLinkInternal()

  const onSubmit = (inputs: RecsEndpointInputsType) => {
    const params = new URLSearchParams()

    if (inputs.commander) params.set('commander', inputs.commander)
    if (inputs.commander2) params.set('commander2', inputs.commander2)
    if (inputs.decklist) params.set('decklist', inputs.decklist)
    if (inputs.excludeLands) params.set('excludeLands', '1')

    redirectUrl(`/recs?${params.toString()}`)
  }

  return (
    <section className={styles.container}>
      <div className={styles.top}>
        <h2 className={styles.headerMain}>
          Get <span>Started</span>
        </h2>
        <p className={styles.subheaderMain}>Start using EDHREC now!</p>
      </div>
      <div className={styles.content}>
        <div className={styles.search}>
          <Splash align='right' backgroundImages={[CARDART.MAGNIFIYING_GLASS]} isMasked opacityPreset='strong' />
          <div className={styles.inner}>
            <h3 className={styles.headerCallout}>
              <IconWithLabel iconBefore='magnifyingGlass'>Search</IconWithLabel>
            </h3>
            <p className={styles.subheaderCallout}>
              Find cards, commanders, precons, tags, sets, and more with the searchbar below or in the header!
            </p>
            <Searchbar isPrimary={false} size='lg' />
          </div>
        </div>
        <div className={styles.browse}>
          <Splash align='cover' backgroundImages={[CARDART.PONDER]} />
          <div className={styles.inner}>
            <h3 className={styles.headerCallout}>
              <IconWithLabel iconBefore='book'>Browse</IconWithLabel>
            </h3>
            <p className={styles.subheaderCallout}>
              Choose your favorite color identity to check out top commanders, card staples, landbases, and more!
            </p>
            <HomeStartedBrowse />
          </div>
        </div>
        <div className={styles.rec}>
          <Splash align='cover' backgroundImages={[CARDART.PATIENT_REBUILDING]} />
          <div className={styles.inner}>
            <h3 className={styles.headerCallout}>
              <IconWithLabel iconBefore='cards'>Get Deck Recs</IconWithLabel>
            </h3>
            <RecsForm onSubmit={onSubmit} />
          </div>
        </div>
      </div>
    </section>
  )
}
